var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8382 0.0917969C11.8441 0.13886 10.6186 0.764444 9.91626 1.64293C9.2734 2.40182 8.72334 3.63234 8.86221 4.78733C9.98519 4.8834 11.1108 4.20987 11.8112 3.35491C12.5017 2.47448 12.9552 1.29579 12.8382 0.0917969ZM12.7102 5.38479C11.0734 5.38479 9.9012 6.2657 9.13733 6.2657C8.36155 6.2657 7.20209 5.39244 5.8628 5.39244C4.2259 5.39244 2.62358 6.40906 1.77834 7.88954C0.0422433 10.8486 1.32822 15.2306 3.00679 17.6406C3.83018 18.8329 4.82191 20.0918 6.1612 20.0918C7.38935 20.0467 7.80245 19.3564 9.28459 19.3564C10.7766 19.3564 11.2199 20.0918 12.5591 20.0918C13.8984 20.0918 14.71 18.8788 15.5314 17.6866C16.4699 16.3335 16.8523 15.0129 16.8761 14.9443C16.8543 14.9228 14.2803 13.9465 14.2565 11.011C14.2346 8.5559 16.283 7.38556 16.3762 7.3189C15.2195 5.62075 13.3039 5.38479 12.8575 5.38479H12.7102Z",
    fill: "#3A476A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplePay);
export default __webpack_public_path__ + "static/media/apple-pay.47ba67820030849d84dabb5cce862508.svg";
export { ForwardRef as ReactComponent };